/* unplugin-vue-components disabled */import { render } from "./todoComponent.vue?vue&type=template&id=0b6154eb&scoped=true"
import script from "./todoComponent.vue?vue&type=script&lang=js"
export * from "./todoComponent.vue?vue&type=script&lang=js"

import "./todoComponent.vue?vue&type=style&index=0&id=0b6154eb&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b6154eb"]])

export default __exports__